import { render, staticRenderFns } from "./BtnDetailStatus.vue?vue&type=template&id=24a49da3&scoped=true&"
import script from "./BtnDetailStatus.vue?vue&type=script&lang=js&"
export * from "./BtnDetailStatus.vue?vue&type=script&lang=js&"
import style0 from "./BtnDetailStatus.vue?vue&type=style&index=0&id=24a49da3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a49da3",
  null
  
)

export default component.exports